import { Component, Input, TemplateRef } from '@angular/core';
import { InputText } from 'primeng/inputtext';
import { ReactiveFormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';
import { DynamicFieldModel } from '../../../index';

@Component({
  selector: 'shared-ui-dynamic-form-textinput',
  imports: [InputText, ReactiveFormsModule, NgTemplateOutlet],
  template: `
    @if (template) {
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ fieldModel }"></ng-container>
    } @else {
      <input type="text" pInputText [formControl]="fieldModel.control!" />
    }
  `,
  styles: ``,
})
export class DynamicFormTextinputComponent {
  @Input() template?: TemplateRef<unknown>;
  @Input({ required: true }) fieldModel!: DynamicFieldModel;
}
